import { createSelector } from 'reselect'
import {
    identity,
    EMPTY_STR,
    EMPTY_IMMUTABLE_MAP
} from '@lacele/const'
import {
    SESSION_CREATE,
    SESSION_UPDATE,
    SESSION_MERGE_IN,
    SESSION_INVALIDATE
} from './types'
import {
    getLogoutActionTarget
} from './utils'

const defaultState = EMPTY_IMMUTABLE_MAP
const NOT_UPDATABLE_FIELDS = ['token', 'username', 'authorizationToken']

export default (state, action) => {
    const actualState = state || defaultState
    switch (action.type) {
        case SESSION_CREATE:
            return actualState.withMutations((mutableState) => (
                mutableState.clear().merge(action.payload)
            ))
        case SESSION_UPDATE: {
            const {
                // not updatable fields
                token,
                username,
                authorizationToken,
                ...payload
            } = action.payload
            return actualState.merge(payload)
        }
        case SESSION_MERGE_IN: {
            const {
                path
            } = action.payload
            if (path
                && path.length > 0
                && !NOT_UPDATABLE_FIELDS.includes(path[0])) {
                return actualState.mergeIn(path, action.payload.data)
            }
            return actualState
        }
        case SESSION_INVALIDATE:
            return actualState.withMutations((mutableState) => (
                mutableState.delete('xAuthToken')
                    .delete('authorizationToken')
                    .delete('role')
                    .delete('sidebar')
            ))
        default:
            return actualState
    }
}

export const getXAuthToken = (state) => state.get('xAuthToken')
export const getUsername = (state) => state.get('username')
export const getSidebar = (state) => state.get('sidebar')
export const getRole = (state) => state.get('role')
export const getIdCentro = (state) => state.get('idCentro')
export const getIdOperatore = (state) => state.get('id')
export const getGruppoRand = (state) => state.get('gruppoRand')
export const getPrediabete = (state) => state.get('prediabete')

export const isLogged = createSelector(
    getXAuthToken,
    (xAuthToken) => !!xAuthToken
)

// TODO
/*
export const getAuthorities = createSelector(
    getInfo,
    (info) => {
        const authorities = info ? info.get('authorities') : null
        return authorities || EMPTY_IMMUTABLE_MAP
    }
)
*/

export const getLogoutAction = createSelector(
    identity,
    () => getLogoutActionTarget(),
    (state, target) => state.get(target) || EMPTY_STR
)
